import type { CSSProperties } from 'react';
import { TEXT_TAGS } from '../constants';
import { isElementInsideWidget } from './is-element-inside-widget';

// CSS properties that can be processed for accessibility
// type SupportedCSSProperty = 'fontSize' | 'lineHeight' | 'letterSpacing';

export type CSSPropertyName = keyof CSSProperties & keyof CSSStyleDeclaration;

export function processTextElements(
  elements: Node[],
  cssProperties: CSSPropertyName[],
  processedElements: Set<HTMLElement>
) {
  const elementsToProcess = elements.filter(
    (element): element is HTMLElement =>
      element instanceof HTMLElement &&
      !isElementInsideWidget(element) &&
      !processedElements.has(element) &&
      TEXT_TAGS.includes(element.tagName.toLowerCase())
  );

  elementsToProcess.forEach((element) => {
    cssProperties.forEach((property) => {
      if (applyTextProperty(element, property)) {
        processedElements.add(element);
      }
    });
  });
}

function applyTextProperty(element: HTMLElement, property: CSSPropertyName) {
  const kebabProperty = property.replace(/([A-Z])/g, '-$1').toLowerCase();
  const computedStyle = window.getComputedStyle(element);
  const value = parseFloat(computedStyle[property]);
  const hasAttribute = element.hasAttribute(`data-eapps-${kebabProperty}`);

  if (isNaN(value) || hasAttribute) {
    return false;
  }

  element.setAttribute(`data-eapps-${kebabProperty}`, value.toString());

  return true;
}
